import DefaultRequest from "@/api/DefaultRequest";
class User {
    constructor() { }
    getMe() {
        return DefaultRequest.get("users/me");
    }
    getList() {
        return DefaultRequest.get("users");
    }
    getAccessGroupList() {
        return DefaultRequest.get("access-groups");
    }
    getAccessOptions() {
        return DefaultRequest.get("users/access-options");
    }
    getUser(userId) {
        return DefaultRequest.get("users/" + userId);
    }
    updateUser(userId, params) {
        return DefaultRequest.post("users/" + userId, { ...params, _method: "PATCH" }, true);
    }
    updatePassword(userId, password, confirmation) {
        return DefaultRequest.post(`users/${userId}/password`, { password, password_confirmation: confirmation, _method: "PATCH" }, true);
    }
}
export default new User();
